import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import forecast from "./modules/forecast";
import qtime from "./modules/qtime";
import reports from "./modules/reports";
import qtimeReports from "./modules/qtimeReports";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    auth,
    forecast,
    qtime,
    reports,
    qtimeReports
  }
});
